import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { consoleBffRequestUrl } from "@/api/client";
import { LocalGatewayInstallerDownload } from "@/features/storages/LocalGatewayInstallerDownload";
import portalRelease from "../../../../kintone-plugin/src/runtime/portal-release.json";

export function DownloadsPage() {
  return (
    <div className="mx-auto max-w-4xl space-y-8">
      <header className="space-y-2">
        <h1 className="text-2xl font-bold">ダウンロード</h1>
        <p className="text-sm text-muted-foreground">EXTONE Drive の導入や再インストールに必要なファイルをダウンロードできます。</p>
      </header>
      <section aria-labelledby="gateway-download-title" className="space-y-3">
        <h2 id="gateway-download-title" className="text-lg font-semibold">Drive Gateway</h2>
        <p className="text-sm text-muted-foreground">ローカルフォルダや共有フォルダを利用するPCにインストールします。</p>
        <LocalGatewayInstallerDownload />
      </section>
      <section aria-labelledby="plugin-download-title" className="space-y-3 border-t pt-6">
        <h2 id="plugin-download-title" className="text-lg font-semibold">kintoneプラグイン</h2>
        <p className="text-sm text-muted-foreground">kintoneのシステム管理でZIPを登録し、利用するアプリに追加します。登録にはkintone側の管理権限が必要です。</p>
        <Button asChild variant="outline"><a href={consoleBffRequestUrl("/console-bff/plugin-package")}><Download className="mr-2 h-4 w-4" aria-hidden="true" />プラグイン（ZIP）をダウンロード</a></Button>
      </section>
      <section aria-labelledby="portal-download-title" className="space-y-3 border-t pt-6">
        <h2 id="portal-download-title" className="text-lg font-semibold">ポータル／スレッド用JS</h2>
        <p className="text-sm text-muted-foreground">ポータルやスペースのスレッドに貼り付けたアプリ一覧で、外部添付を表示・操作する場合に登録します。</p>
        <p className="text-sm">登録するのはこの1ファイルだけです。必要な外部JSは自動で読み込まれます。</p>
        <Button asChild variant="outline"><a href={`/kdrive/portal/${portalRelease.globalVersion}/extone-drive-portal.js`} download="extone-drive-portal.js"><Download className="mr-2 h-4 w-4" aria-hidden="true" />ポータル／スレッド用JSをダウンロード</a></Button>
        <p className="text-xs text-muted-foreground">バージョン {portalRelease.globalVersion}</p>
        <details className="text-sm leading-7">
          <summary className="cursor-pointer font-medium">登録・更新・撤去の手順</summary>
          <ol className="list-decimal space-y-1 pl-6 pt-2">
            <li>kintoneシステム管理の「JavaScript / CSSでカスタマイズ」を開きます。kintoneのシステム管理権限が必要です。</li>
            <li>PC用のJavaScriptファイルに、ダウンロードしたJSを追加します。ほかの登録済みファイルは残してください。</li>
            <li>適用範囲を確認して保存し、対象画面を再読み込みします。</li>
          </ol>
          <p className="pt-2">更新時は、このサービスの登録済みJSを新しいファイルに置き換えます。利用を終了する場合は、このJSだけを登録から削除して保存し、対象画面を再読み込みしてください。</p>
        </details>
      </section>
    </div>
  );
}
